module.exports = __webpack_public_path__ + "static/profile-a31ed053622008ee1238631b0c6b20e9.png";